<template>
    <div id="frameButtons">
      <h2 v-if="product != 'frame'" style="text-align: left; position: relative; top: 5px;">{{getText.title}}</h2>
      <h2 v-if="product == 'frame'" style="text-align: left; position: relative; top: 5px;">{{getText.titleFrame}}</h2>
      <v-radio-group v-if="product == 'table'" v-model="table">
        <v-radio
          :label="getText.open"
          color="var(--accentColor)"
          value="open"
        ></v-radio>
        <v-radio
          :label="getText.closed + ' (+' + getTableClosedPrice + '€)'"
          color="var(--accentColor)"
          value="closed"
        ></v-radio>
      </v-radio-group>

      <!-- Bench -->
      <v-radio-group v-model="bench" v-if="product == 'bench'">
        <v-radio
          :label="getText.simple"
          color="var(--accentColor)"
          value="simple"
        ></v-radio>
        <v-radio
          :label="getText.massiv + ' (+' + getBenchMassivePrice + '€)'"
          color="var(--accentColor)"
          value="massive"
        ></v-radio>
      </v-radio-group>

      <!-- Frame -->
      <v-radio-group v-model="frame" v-if="product == 'frame'">
        <v-radio
          :label="getText.mirror"
          color="var(--accentColor)"
          value="mirror"
        ></v-radio>
        <v-radio
          :label="getText.whiteboard"
          color="var(--accentColor)"
          value="whiteboard"
        ></v-radio>
        <v-radio
          :label="getText.blackboard"
          color="var(--accentColor)"
          value="blackboard"
        ></v-radio>
        <v-radio
          :label="getText.passepartout"
          color="var(--accentColor)"
          value="passepartout"
        ></v-radio>
        <v-radio
          :label="getText.none"
          color="var(--accentColor)"
          value="none"
        ></v-radio>
      </v-radio-group>

      <!-- Stool -->
      <v-radio-group v-model="stool" v-if="product == 'stool'">
        <v-radio
          :label="getText.open"
          color="var(--accentColor)"
          value="simple"
        ></v-radio>
        <v-radio
          :label="getText.massiv + ' (+' + getStoolMassivePrice + '€)'"
          color="var(--accentColor)"
          value="massive"
        ></v-radio>
      </v-radio-group>
    </div>
</template>

<script>

export default {
  name: 'FrameButtons',
  props: ['product'],
  components: {
    // HelloWorld
  },
  data() {
    return{
      table: 'open',
      bench: 'simple',
      stool: 'simple',
      frame: 'none'
    }
   },
   mounted (){
     switch (this.product){
       case 'table':
        this.table = this.$store.getters.getTableConfig.frameType;
       break;
       case 'bench':
        this.bench = this.$store.getters.getBenchConfig.frameType;
       break;
       case 'frame':
        this.frame = this.$store.getters.getFrameConfig.filling.type;
       break;
       case 'stool':
        this.stool = this.$store.getters.getStoolConfig.frameType;
       break;
       default:
       break;
     }
   },
   computed: {
     getText(){
       return this.$store.getters.getText.configurator.frame
     },
     getTableClosedPrice(){
       return this.$store.getters.getTableConfig.frameTypes.closed
     },
     getBenchMassivePrice(){
       return this.$store.getters.getBenchConfig.frameTypes.massive
     },
     getStoolMassivePrice(){
       return this.$store.getters.getStoolConfig.frameTypes.massive
     },
   },
   watch: {
     table: function(){
        this.$store.dispatch("changeTableConfig", {change: 'frame', value: this.table});
     },
     bench: function(){
        this.$store.dispatch("changeBenchConfig", {change: 'frame', value: this.bench});
     },
     frame: function(){
        this.$store.dispatch("changeFrameConfig", {change: 'filling', value: this.frame});
     },
     stool: function(){
        this.$store.dispatch("changeStoolConfig", {change: 'frame', value: this.stool});
     },
   },
   methods: {
 }
}
</script>

<style scoped>
  #frameButtons{
    /* position: relative; */
    /* display: grid;
    grid-template-columns: 1fr 1fr; */
  }

</style>
